import { mapActions, mapGetters, mapMutations } from 'vuex'
import VueJsonPretty from 'vue-json-pretty'

export default {
  props: {
    readonly: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  components: {
    VueJsonPretty
  },
  data () {
    return {
      rules: {
        mock: () => (!this.mock || !!this.isValidJSONString) || 'O JSON informado não é válido'
      },
      mock: null,
      viewMock: false,
      name: '',
      isLoading: false,
      isLoadingParamField: false,
      isLoadingAddFieldAvailable: false,
      isLoadingFieldRequired: false,
      isLoadingInternalField: false,
      dialog: false,
      fieldName: '',
      paramName: '',
      paramValue: '',
      requestField: '',
      newFieldInternal: '',
      providerTypes: [
        { name: 'PF', value: 'PF' },
        { name: 'PJ', value: 'PJ' },
        { name: 'Outro', value: null }
      ],
      selectedType: '',
      minimumPrice: null,
      cost: null,
      description: '',
      providerSources: [],
      providerClassification: [],
      selectedProviderClassification: '',
      selectedProviderSources: '',
      selectedFieldAvailable: {},
      selectedParamField: {},
      selectedFieldRequired: {},
      selectedInternalField: {},
      selectedParamFieldToView: {},
      valueLight: null,
      valueStandard: null,
      valueBusiness: null,
      valueEnterprise: null,
      metrics: [
        { name: 'Alto', value: '5ba98593-3fa1-40b3-b773-6a0a25f8931a' },
        { name: 'Baixo', value: '8b322de6-61d2-487a-bd93-fee10f480334' },
        { name: 'Local', value: '63c68219-d34c-43d9-98e7-82595e1c05df' }
      ],
      planTypes: [],
      sources: []
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedSystemProvider',
      'getterPlanType',
      'getterSources',
      'getterPlanType'
    ]),
    isValidJSONString () {
      let result = null

      try {
        result = JSON.parse(this.mock)
      } catch (e) {
        result = null
      }

      return result
    },
    idSelectedProvider () {
      return this.getterSelectedSystemProvider.idSystemProvider
    },
    idPlanTypes () {
      return this.getterPlanType
    },
    internalRequestFields () {
      return this.getterSelectedSystemProvider.requestFields.filter((item) => item.internal)
    },
    notInternalRequestFields () {
      return this.getterSelectedSystemProvider.requestFields.filter((item) => !item.internal)
    },
    isDisabled () {
      return this.selectedType === '' || !this.minimumPrice || !this.cost || (this.mock && !this.isValidJSONString) || (this.getterSelectedSystemProvider && this.getterSelectedSystemProvider.fieldsAvaliableOnProvider && this.getterSelectedSystemProvider.fieldsAvaliableOnProvider.length === 0) || (this.getterSelectedSystemProvider && this.getterSelectedSystemProvider.requestFields && this.getterSelectedSystemProvider.requestFields.length === 0)
    },
    options () {
      return {
        loading: this.isLoadingParamField || this.isLoading
      }
    },
    optionsAddFieldAvailable () {
      return {
        loading: this.isLoadingAddFieldAvailable && Object.keys(this.selectedFieldAvailable).length === 0
      }
    },
    optionsAddFieldRequired () {
      return {
        loading: this.isLoadingFieldRequired && Object.keys(this.selectedFieldRequired).length === 0
      }
    },
    optionsInternalField () {
      return {
        loading: this.isLoadingInternalField && Object.keys(this.selectedInternalField).length === 0
      }
    }
  },
  mounted () {
    this.setProviderInfo()
    this.getSystemProviderClassification()
    this.getSystemProviderSalesValues()
    this.getSources()
    this.getPlanTypes()
    this.sources = this.getterSources
    this.providerSources = this.getterSources.map((item) => ({
      label: item.sourceName,
      value: item.idSource
    }))
  },
  beforeDestroy () {
    this.SET_SELECTED_SYSTEM_PROVIDER()
  },
  methods: {
    ...mapActions([
      'actionEditSystemProvider',
      'actionRemoveFieldAvailable',
      'actionAddFieldAvailable',
      'actionAddParamsFields',
      'actionEditParamsFields',
      'actionAddRequestFields',
      'actionRemoveRequestFields',
      'actionEditRequestFields',
      'actionGetAllSystemProviders',
      'actionGetSystemProviderClassifications',
      'actionGetSystemProviderSalesValues',
      'actionGetSources',
      'actionGetPlanTypes'
    ]),
    ...mapMutations([
      'SET_SELECTED_SYSTEM_PROVIDER'
    ]),
    async getSystemProviderClassification () {
      this.actionGetSystemProviderClassifications().then((response) => {
        this.providerClassification = response.data.map((item) => ({
          label: item.name,
          value: item.idSystemProviderClassification
        }))
      }).catch((error) => {
        console.log(error)
      })
    },
    getSources () {
      this.actionGetSources()
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    getPlanTypes () {
      this.actionGetPlanTypes()
      this.planTypes = this.getterPlanType
    },
    async getSystemProviderSalesValues () {
      this.actionGetSystemProviderSalesValues().then((response) => {
        const sales = response.data.filter((item) => item.idSystemProvider === this.idSelectedProvider)
        sales.forEach(element => {
          this.planTypes.forEach(item => {
            if (element.idPlanType === item.idPlanType) {
              if (item.name === 'Light') {
                this.valueLight = element.saleValue
              }
              if (item.name === 'Standard') {
                this.valueStandard = element.saleValue
              }
              if (item.name === 'Business') {
                this.valueBusiness = element.saleValue
              }
              if (item.name === 'Enterprise') {
                this.valueEnterprise = element.saleValue
              }
            }
          })
          this.valueLight = parseFloat(this.valueLight).toFixed(2)
          this.valueStandard = parseFloat(this.valueStandard).toFixed(2)
          this.valueBusiness = parseFloat(this.valueBusiness).toFixed(2)
          this.valueEnterprise = parseFloat(this.valueEnterprise).toFixed(2)
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    setParamFieldToEdit (item) {
      this.selectedParamFieldToView = {}

      if (Object.keys(this.selectedParamField).length === 0 || (item.idParamsField !== this.selectedParamField.idParamsField)) {
        const {
          name,
          value
        } = item

        this.paramName = name
        this.paramValue = value

        this.selectedParamField = item
      } else {
        this.paramName = ''
        this.paramValue = ''
        this.selectedParamField = {}
      }
    },
    setParamFieldToView (item) {
      const {
        name,
        value
      } = item

      this.paramName = name
      this.paramValue = value

      this.selectedParamField = {}
      this.selectedParamFieldToView = item
    },
    cleanFields () {
      this.paramName = this.paramValue = ''
      this.selectedParamFieldToView = this.selectedParamField = {}
    },
    managerParamField () {
      if (Object.keys(this.selectedParamFieldToView).length === 0) {
        this.isLoadingParamField = true

        if (Object.keys(this.selectedParamField).length === 0) {
          const paramField = {
            name: this.paramName,
            value: this.paramValue,
            idSystemProvider: this.getterSelectedSystemProvider.idSystemProvider
          }

          this.actionAddParamsFields(paramField)
            .then(() => {
              this.paramName = this.paramValue = ''

              this.isLoadingParamField = false
            })
            .catch(() => {
              this.sendToast({
                text: 'Ocorreu um erro ao adicionar o ParamField, tente novamente mais tarde!',
                type: 'danger'
              })

              this.isLoadingParamField = false
            })
        } else {
          const updatedParams = {
            ...this.selectedParamField,
            value: this.paramValue
          }

          this.actionEditParamsFields(updatedParams)
            .then(() => {
              this.paramName = this.paramValue = ''
              this.selectedParamField = {}

              this.isLoadingParamField = false
            })
            .catch(() => {
              this.sendToast({
                text: 'Ocorreu um erro ao editar o ParamField, tente novamente mais tarde!',
                type: 'danger'
              })

              this.isLoadingParamField = false
            })
        }
      } else {
        this.sendToast({
          text: 'Você está visualizando um ParamField!',
          type: 'warning'
        })
      }
    },
    mapSources (item) {
      const source = this.getterSources.find((source) => source.idSource === item)


      if (source) {
        return { text: source.sourceName, value: source.idSource }
      }

      return ''
    },
    setProviderInfo () {
      this.dialog = true
      if (Object.keys(this.getterSelectedSystemProvider).length > 0) {
        this.minimumPrice = this.getterSelectedSystemProvider.minimumPrice.toString()
        this.cost = this.getterSelectedSystemProvider.cost.toString()
        this.selectedProviderSources = this.mapSources(this.getterSelectedSystemProvider.idSource)

        this.selectedProviderClassification = this.getterSelectedSystemProvider.idSystemProviderClassification
        this.description = this.getterSelectedSystemProvider.description
        this.mock = this.getterSelectedSystemProvider.mock

        if (Object.prototype.hasOwnProperty.call(this.getterSelectedSystemProvider, 'type')) {
          this.selectedType = this.getterSelectedSystemProvider.type
        }

        if (this.minimumPrice.indexOf('.') === -1) {
          this.minimumPrice = `${this.minimumPrice},00`
        } else {
          const val = this.minimumPrice.split('.')

          if (val[1] !== undefined && val[1].length === 1) {
            this.minimumPrice = `${this.minimumPrice.replace('.', ',')}0`
          } else {
            this.minimumPrice = this.minimumPrice.replace('.', ',')
          }
        }

        if (this.cost.indexOf('.') === -1) {
          this.cost = `${this.cost},00`
        } else {
          const val = this.cost.split('.')

          if (val[1] !== undefined && val[1].length === 1) {
            this.cost = `${this.cost.replace('.', ',')}0`
          } else {
            this.cost = this.cost.replace('.', ',')
          }
        }
      }
    },
    editProvider () {
      if (!this.isDisabled) {
        const systemProvider = {
          ...this.getterSelectedSystemProvider,
          type: this.selectedType,
          minimumPrice: !this.minimumPrice ? 0 : parseFloat(this.minimumPrice.toString().replace('.', '').replace(',', '.')),
          cost: !this.cost ? 0 : parseFloat(this.cost.toString().replace('.', '').replace(',', '.')),
          idSource: this.selectedProviderSources.value === undefined ? this.selectedProviderSources : this.selectedProviderSources.value,
          description: this.description,
          mock: this.mock,
          idSystemProviderClassification: this.selectedProviderClassification
        }

        this.isLoading = true


        this.actionEditSystemProvider(systemProvider)
          .then(() => {
            this.closeModal()

            this.actionGetAllSystemProviders()

            this.sendToast({
              text: 'Provider atualizado com sucesso!',
              type: 'success'
            })
          })
          .catch(() => {
            this.sendToast({
              text: 'Ocorreu um erro ao atualizar o provider, tente novamente mais tarde!',
              type: 'danger'
            })

            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'Os campos não foram preenchidos corretamente!',
          type: 'warning'
        })
      }
    },
    addFieldAvailable () {
      const fieldAvailable = {
        idSystemProvider: this.getterSelectedSystemProvider.idSystemProvider,
        name: this.fieldName
      }

      this.isLoadingAddFieldAvailable = true

      this.actionAddFieldAvailable(fieldAvailable)
        .then(() => {
          this.fieldName = ''

          this.isLoadingAddFieldAvailable = false
        })
        .catch(() => {
          this.isLoadingAddFieldAvailable = false

          this.sendToast({
            text: 'Ocorreu um erro ao adicionar um campo disponível, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    removeFieldAvaliable (item) {
      this.selectedFieldAvailable = item
      this.isLoadingAddFieldAvailable = true

      this.actionRemoveFieldAvailable(item)
        .then(() => {
          this.isLoadingAddFieldAvailable = false
          this.selectedFieldAvailable = {}
        })
        .catch(() => {
          this.isLoadingAddFieldAvailable = false
          this.selectedFieldAvailable = {}

          this.sendToast({
            text: 'Ocorreu um erro ao remover um campo disponível, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    removeFieldRequired (item) {
      this.selectedFieldRequired = item
      this.isLoadingFieldRequired = true

      this.actionRemoveRequestFields(item)
        .then(() => {
          this.isLoadingFieldRequired = false
          this.selectedFieldRequired = {}
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao remover o campo requerido, tente novamente mais tarde!',
            type: 'danger'
          })

          this.isLoadingFieldRequired = false
          this.selectedFieldRequired = {}
        })
    },
    addRequestField () {
      const requestField = {
        name: this.requestField,
        required: false,
        internal: false,
        idSystemProvider: this.getterSelectedSystemProvider.idSystemProvider
      }

      this.isLoadingFieldRequired = true

      this.actionAddRequestFields(requestField)
        .then(() => {
          this.requestField = ''

          this.isLoadingFieldRequired = false
        })
        .catch(() => {
          this.isLoadingFieldRequired = false

          this.sendToast({
            text: 'Ocorreu um erro ao adicionar o campo requerido, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    editInternalField () {
      const params = {
        ...this.newFieldInternal,
        internal: true,
        minimumPrice: !this.minimumPrice ? 0 : parseFloat(this.minimumPrice.toString().replace('.', '').replace(',', '.'))
      }

      this.isLoadingInternalField = true

      this.actionEditRequestFields(params)
        .then(() => {
          this.actionGetAllSystemProviders()

          this.newFieldInternal = ''

          this.isLoadingInternalField = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao atualizar o campo interno, tente novamente mais tarde!',
            type: 'danger'
          })

          this.isLoadingInternalField = false
        })
    },
    deleteInternalField (item) {
      const updatedItem = {
        ...item,
        internal: false
      }

      this.selectedInternalField = item
      this.isLoadingInternalField = true

      this.actionEditRequestFields(updatedItem)
        .then(() => {
          this.sendToast({
            text: 'Campo interno removido com sucesso',
            type: 'success'
          })

          this.selectedInternalField = {}
          this.isLoadingInternalField = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Falha ao remover o InternalField',
            type: 'danger'
          })

          this.selectedInternalField = {}
          this.isLoadingInternalField = false
        })
    }
  }
}
